// extracted by mini-css-extract-plugin
export default {"outerContainer":"Navbar_outerContainer__kkUdl","container":"Navbar_container__0ThlM","novellaLogo":"Navbar_novellaLogo__j12yD","extraLogo":"Navbar_extraLogo__l49WD"};